import * as React from "react";
import { FormattedMessage } from "react-intl";
import VingleDialog, { VingleDialogTypes } from "app/vingleDialog";
import SolidReasonInput, {
  VALIDATION_ICON_TYPE,
} from "common/components/solidReasonInput";
import CheckBox from "common/components/checkBox";
// styles

const styles = require("app/account/edit/components/deactivateAccountDialog.scss");

interface IProps {
  isOpen: boolean;
  isLoading: boolean;
  onRequestClose: () => void;
  deactivateHandler: (username: string, withContent: boolean) => void;
  onUsernameChangeHandler?: React.ReactEventHandler<HTMLInputElement>;
  failedReason?: string;
  usernameFailedOrNot?: boolean;
}

interface IState {
  username: string;
  withContent: boolean;
  usernameFailedOrNot?: boolean;
}

class DeactivateAccountDialog extends React.PureComponent<IProps, IState> {
  public readonly state: IState = {
    username: "",
    withContent: false,
    usernameFailedOrNot: this.props.usernameFailedOrNot,
  };

  public componentDidUpdate(prevProps: IProps) {
    if (prevProps.isOpen !== this.props.isOpen) {
      this.setState({
        username: "",
      });
    }

    if (this.state.usernameFailedOrNot !== this.props.usernameFailedOrNot) {
      this.setState({
        usernameFailedOrNot: this.props.usernameFailedOrNot,
      });
    }
  }

  public render() {
    const { isOpen, onRequestClose, failedReason, isLoading } = this.props;
    const { usernameFailedOrNot } = this.state;

    let usernameRightIcon: VALIDATION_ICON_TYPE;
    if (usernameFailedOrNot === undefined) {
      usernameRightIcon = VALIDATION_ICON_TYPE.NONE;
    } else if (usernameFailedOrNot) {
      usernameRightIcon = VALIDATION_ICON_TYPE.FAILED;
    } else {
      usernameRightIcon = VALIDATION_ICON_TYPE.SUCCESS;
    }

    return (
      <VingleDialog
        onRequestClose={onRequestClose}
        open={isOpen}
        type={VingleDialogTypes.BASIC}
        title={<FormattedMessage id="user_edit.deactivate_title" />}
        onRequestSubmit={this.onSubmit}
        submitButtonText={
          <FormattedMessage id="user_edit.deactivate_confirm" />
        }
        cancelButtonText={<FormattedMessage id="user_edit.deactivate_cancel" />}
        disableSubmitButtons={
          isLoading ||
          this.state.usernameFailedOrNot ||
          this.state.username.length === 0
        }
      >
        <div>
          <div className={styles.message}>
            <FormattedMessage id="user_edit.deactivate_message" />
          </div>
          <div>
            <label className={styles.subTitle}>
              <FormattedMessage id="user_edit.deactivate_password" />
            </label>
            <SolidReasonInput
              wrapperClassName={styles.input}
              rightItemWrapperClassName={styles.inputRightItemWrapper}
              value={this.state.username}
              inputType="text"
              onChange={this.onUsernameChange}
              placeholder=""
              isDebounce={false}
              reason={failedReason}
              rightIconType={usernameRightIcon}
            />
          </div>
          <div className={styles.checkBoxWrapper}>
            <CheckBox
              onChange={this.handleCheckBoxChange}
              checked={this.state.withContent}
              checkedValue={true}
              unCheckedValue={false}
              checkBoxClassName={styles.checkBoxIcon}
            >
              <span className={styles.checkBoxLabel}>
                <FormattedMessage id="user_edit.deactivate_with_content" />
              </span>
            </CheckBox>
          </div>
        </div>
      </VingleDialog>
    );
  }

  private readonly onUsernameChange = (
    e: React.SyntheticEvent<HTMLInputElement>,
  ) => {
    const value = e.currentTarget.value;
    this.setState({
      username: value,
      usernameFailedOrNot: undefined,
    });

    if (this.props.onUsernameChangeHandler) {
      this.props.onUsernameChangeHandler(e);
    }
  };

  private readonly onSubmit = () => {
    this.props.deactivateHandler(this.state.username, this.state.withContent); // pass delete with content check state
  };

  private readonly handleCheckBoxChange = (state: any) => {
    this.setState({
      withContent: Boolean(state),
    });
  };
}
export default DeactivateAccountDialog;
